import { render, staticRenderFns } from "./ArchivPage.vue?vue&type=template&id=236a0637&scoped=true&"
import script from "./ArchivPage.vue?vue&type=script&lang=ts&"
export * from "./ArchivPage.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "236a0637",
  null
  
)

export default component.exports